// import { textFileTruncate } from "@/Util/textFileTruncate";
import { useRef, useState } from "react";

interface InputFileProps {
    onChange?: (file: File | null) => void;
}

export default function InputSingleFile({ onChange }: InputFileProps) {
    const fileInputRef = useRef<HTMLInputElement>(null);
    const [, setSelectedFile] = useState<File | null>(null);

    const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const file = event.target.files?.[0] || null;
        setSelectedFile(file);
        onChange?.(file);
    };

    return (
        <div className="flex flex-col gap-2">

        <div>
            <label
            htmlFor="file-upload"
            className="cursor-pointer w-full flex justify-center items-center px-6 h-16 rounded-[8px] border-2 border-dashed border-blue-200 bg-gray-150"
            >
            <img src="/assets/svg/icon-upload-blue.svg" alt="icone upload" />
            <div className="flex-1 flex justify-center">
                <span className="max-w-64 text-sm text-center">
                Clique para adicionar ou arraste e solte um arquivo aqui
                </span>
            </div>
            </label>
            <input
            ref={fileInputRef}
            id="file-upload"
            type="file"
            className="hidden"
            onChange={handleFileChange}
            />
        </div>
        </div>
    );
}
